
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetohyderabadinnova() {



    const cardData =
    {
        keyword: 'Pune to Hyderabad Innova Crysta Rental Cab',
        heading: 'Meghana Cab : Pune to Hyderabad Innova Crysta Rental Cab',
        headingDescription: 'Meghana Cab offers Pune to Hyderabad Innova Crysta Rental Cab, delivering a premium, comfortable, and convenient long-distance travel experience. Ideal for families, business travelers, and groups, our Innova Crysta vehicles feature plush leather interiors, spacious seating, ample luggage space, and advanced safety amenities—perfect for the roughly 560 km journey. Whether you are heading to Hyderabad for leisure, work, or a special event, enjoy a smooth ride with experienced chauffeurs familiar with the Pune–Hyderabad route and key stops.',


        top: 'Top Places to Visit in Hyderabad with Meghana Cab',

"topPlaces": [
  {
    "title": "Charminar",
    "description": "Charminar is the most iconic symbol of Hyderabad, built in 1591 by Sultan Muhammad Quli Qutb Shah to commemorate the end of a deadly plague. This Indo-Islamic architectural marvel stands in the heart of the old city with four grand arches and towering minarets. The monument is surrounded by a bustling bazaar where you can shop for bangles, pearls, and street snacks. Its upper floor offers panoramic views of Laad Bazaar and Mecca Masjid. A visit to Hyderabad is incomplete without experiencing the charm and heritage that radiates from Charminar."
  },
  {
    "title": "Golconda Fort",
    "description": "Located 11 km from the city center, Golconda Fort is a majestic 16th-century fortress known for its military architecture, acoustic system, and panoramic views of Hyderabad from its ramparts. Once the capital of the Qutb Shahi dynasty, the fort is spread over 11 kilometers with massive gates, royal palaces, temples, and water supply systems. Don’t miss the unique sound-and-light show in the evening, which narrates the fort’s rich history. It’s also associated with the legendary Koh-i-Noor diamond, believed to have been mined nearby."
  },
  {
    "title": "Hussain Sagar Lake & Buddha Statue",
    "description": "Hussain Sagar is a heart-shaped artificial lake built in 1562 by Ibrahim Quli Qutb Shah. At its center stands a 72-foot-high monolithic statue of Gautama Buddha, carved from white granite and erected in 1992. Accessible via ferry, the statue is especially captivating when lit up at night. The lake is flanked by Necklace Road, Lumbini Park, and Tank Bund—offering boating, street food, and sunset views. It’s a perfect spot for relaxation, photography, and leisurely walks."
  },
  {
    "title": "Ramoji Film City",
    "description": "Spread over 2,000 acres, Ramoji Film City is the world’s largest integrated film studio complex and a top-rated tourist attraction near Hyderabad. Built by film producer Ramoji Rao in 1991, it features film sets, theme parks, gardens, hotels, and live shows. Visitors can explore replicas of airports, streets, palaces, and temples used in Indian films. From guided studio tours to adventure activities and cultural performances, it offers a complete family entertainment experience. Ideal for Bollywood fans and kids alike."
  },
  {
    "title": "Salar Jung Museum",
    "description": "Salar Jung Museum, located on the southern bank of the Musi River, houses one of the largest personal art collections in the world. It features over 40,000 artifacts including sculptures, paintings, textiles, carpets, clocks, and rare manuscripts collected by Nawab Mir Yousuf Ali Khan (Salar Jung III). Highlights include the Veiled Rebecca sculpture, double-sided wooden carving of Mephistopheles and Margaretta, and a vast Quran collection. It’s a paradise for history, art, and culture enthusiasts."
  },
  {
    "title": "Mecca Masjid",
    "description": "One of India’s oldest and largest mosques, Mecca Masjid stands near Charminar and was commissioned by Sultan Muhammad Quli Qutb Shah in 1614. The central arch was made using soil brought from Mecca, hence the name. The mosque features massive granite columns, intricately carved arches, and a tranquil courtyard that can accommodate over 10,000 worshippers. It’s not just a religious site, but also a symbol of Hyderabad’s Islamic architectural heritage and cultural harmony."
  },
  {
    "title": "Chowmahalla Palace",
    "description": "Once the official residence of the Nizams of Hyderabad, Chowmahalla Palace is a stunning architectural complex that blends Persian, Indo-Saracenic, and Rajasthani styles. Spread across 12 acres, it includes grand halls, royal courtyards, vintage cars, regal costumes, and antique furniture. The Khilwat Mubarak hall, with its glittering chandeliers, is a visual masterpiece. The palace gives a vivid glimpse into the royal lifestyle and grandeur of Hyderabad’s bygone era."
  },
  {
    "title": "Birla Mandir",
    "description": "Perched on a 280-foot-high hillock called Naubat Pahad, Birla Mandir is a magnificent white marble temple dedicated to Lord Venkateswara (Balaji). Built by the Birla Foundation in 1976, it offers sweeping views of the city, especially of Hussain Sagar Lake. The temple's architecture blends Dravidian, Rajasthani, and Utkala styles. It's a peaceful spiritual retreat with beautifully carved interiors, tranquil gardens, and a no-mobile-camera policy that enhances the meditative experience."
  },
  {
    "title": "Laad Bazaar",
    "description": "Laad Bazaar, also known as Choodi Bazaar, is one of the oldest markets in Hyderabad, located just beside Charminar. Famous for its glittering lac bangles adorned with stones, this bazaar is a haven for traditional shopping. The narrow alleys are packed with shops selling zari sarees, khara dupattas, ittar (perfume), pearls, and bridal wear. The vibrant chaos, cultural richness, and affordability make it a must-visit destination for anyone wanting to take home a piece of Hyderabad."
  },
  {
    "title": "Nehru Zoological Park",
    "description": "Spread over 380 acres near Mir Alam Tank, Nehru Zoological Park is one of India’s best-maintained zoos. It houses over 1,500 species including white tigers, African lions, Indian elephants, reptiles, birds, and marine life. Visitors can enjoy safari rides, toy trains, aquariums, and educational exhibits. The zoo is perfect for families and school trips, offering a blend of fun, learning, and conservation awareness in a lush, green environment."
  }
],

"services": [
  {
    "name": "Pune to Hyderabad Innova Crysta Cab Booking",
    "description": "Book your Pune to Hyderabad Innova Crysta cab for a smooth, luxurious intercity ride. This long-distance journey becomes hassle-free with our spacious, air-conditioned SUVs, professional chauffeurs, and door-to-door service that ensures safety and comfort throughout the trip."
  },
  {
    "name": "One Way Innova Crysta Pune Hyderabad",
    "description": "Travel one-way from Pune to Hyderabad in a premium Innova Crysta—ideal for relocations, business visits, or short-term stays. Our service includes well-maintained vehicles, flexible pickup schedules, and an experienced chauffeur for a peaceful long ride."
  },
  {
    "name": "Round Trip Innova Crysta Pune Hyderabad",
    "description": "Opt for a round-trip Innova Crysta cab from Pune to Hyderabad for convenience, comfort, and flexibility. Whether it’s a family function, business event, or weekend getaway, this service offers full return planning with a reliable vehicle and expert driver."
  },
  {
    "name": "AC Innova Crysta Taxi Pune Hyderabad",
    "description": "Enjoy your Pune to Hyderabad journey in a fully air-conditioned Innova Crysta, equipped with climate control, plush seating, and ample legroom. Stay relaxed and refreshed even on long drives with our premium AC taxi service."
  },
  {
    "name": "Chauffeur Driven Innova Crysta Pune Hyderabad",
    "description": "Sit back while our professional chauffeurs handle the Pune to Hyderabad route with expertise and care. Our drivers are trained for intercity travel, ensuring punctuality, courteous service, and a stress-free driving experience."
  },
  {
    "name": "Private Innova Crysta Taxi Pune Hyderabad",
    "description": "Travel privately from Pune to Hyderabad with our exclusive Innova Crysta service. With no shared rides, this is perfect for families, executives, or couples who prefer personal space, flexibility, and a customized travel experience."
  },
  {
    "name": "Online Booking Innova Crysta Pune Hyderabad",
    "description": "Book your Pune to Hyderabad Innova Crysta online in minutes. Our digital platform offers real-time availability, easy payments, flexible scheduling, and instant confirmations—making intercity cab booking simple and secure."
  },
  {
    "name": "Family Innova Crysta Trip Pune Hyderabad",
    "description": "Take your family from Pune to Hyderabad in comfort and style. Our Innova Crysta offers captain seats, extra luggage space, and smooth suspension—ideal for long road trips with kids, seniors, or large groups."
  },
  {
    "name": "Budget Innova Crysta Cab Pune Hyderabad",
    "description": "Get luxury travel at affordable rates with our budget Innova Crysta cab from Pune to Hyderabad. Designed for cost-conscious travelers, this service combines comfort, safety, and reliability without breaking the bank."
  }
],
"tableData": [
  ["Pune to Hyderabad Innova Crysta Cab Booking", "One Way Innova Crysta Pune Hyderabad"],
  ["Round Trip Innova Crysta Pune Hyderabad", "AC Innova Crysta Taxi Pune Hyderabad"],
  ["Chauffeur Driven Innova Crysta Pune Hyderabad", "Private Innova Crysta Taxi Pune Hyderabad"],
  ["Online Booking Innova Crysta Pune Hyderabad", "Family Innova Crysta Trip Pune Hyderabad"],
  ["Budget Innova Crysta Cab Pune Hyderabad", ""]
],



"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Hyderabad Innova Crysta Cab Rental",
        "WhyChoosedescription": "Travel from Pune to Hyderabad in a premium Innova Crysta that offers superior comfort, space, and safety. Whether you're traveling for business, family visits, or tourism, enjoy a relaxed and dependable long-distance ride over 550+ km."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable for Long-Distance Journeys",
        "WhyChoosedescription": "Our Innova Crysta cabs come with plush seating, ample legroom, rear AC vents, and large boot space—making it perfect for up to 6–7 passengers. Enjoy a fatigue-free ride across states in a vehicle built for comfort."
    },
    {
        "WhyChooseheading": "Expert Drivers with Intercity Travel Experience",
        "WhyChoosedescription": "Our professional drivers are trained for long-distance travel and are familiar with the Pune–Hyderabad route. They ensure safe driving, timely arrivals, and can handle all travel-related logistics efficiently."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "Each cab is thoroughly cleaned, sanitized, and inspected before the journey to guarantee hygiene and top-notch performance throughout the trip. Your safety and comfort are our top priorities."
    },
    {
        "WhyChooseheading": "Customizable Travel Options and Flexible Scheduling",
        "WhyChoosedescription": "Choose from one-way, round-trip, or multi-day rentals as per your travel needs. Customize pickup points, travel timings, and stopovers to suit your personal or business itinerary."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Our pricing includes fuel, tolls, taxes, and driver allowances—offering complete transparency and no last-minute surprises. Get premium intercity cab service at affordable and honest rates."
    },
    {
        "WhyChooseheading": "Ideal for Corporate Travel, Families, and Group Trips",
        "WhyChoosedescription": "Whether it’s a business meeting, a family visit, or an intercity move, our Innova Crysta cab service is tailored for safe, comfortable, and professional travel for all types of travelers."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Book anytime through our website or support team. Our 24/7 customer service is available to assist with reservations, changes, route preferences, and last-minute travel needs."
    }
]
























    }

const faqData = [
    {
        question: "How do I book an Innova Crysta rental cab from Pune to Hyderabad?",
        answer: "You can book by calling Meghana Cab at +91 9075462128 or through our website for quick and reliable booking."
    },
    {
        question: "What is the distance and estimated travel time from Pune to Hyderabad?",
        answer: "The distance is approximately 560 km, and travel time typically ranges from 9 to 11 hours depending on traffic and route."
    },
    {
        question: "Is Innova Crysta suitable for long-distance travel like Pune to Hyderabad?",
        answer: "Yes, Innova Crysta provides comfort, ample space, and smooth handling, making it perfect for long trips."
    },
    {
        question: "Can I book a one-way or round trip for Pune to Hyderabad?",
        answer: "Yes, we offer both one-way and round-trip cab rental options based on your travel plans."
    },
    {
        question: "How many passengers can travel comfortably in an Innova Crysta?",
        answer: "The vehicle can accommodate 6 to 7 passengers along with their luggage comfortably."
    },
    {
        question: "Are the vehicles sanitized before every trip?",
        answer: "Yes, all our Innova Crysta cabs are thoroughly cleaned and sanitized prior to each journey for your safety."
    },
    {
        question: "Do your drivers have experience with Pune to Hyderabad routes?",
        answer: "Yes, our drivers are skilled and familiar with the best routes to ensure a smooth and safe journey."
    },
    {
        question: "What is included in the rental fare?",
        answer: "The fare covers driver charges, fuel, and tolls. Additional waiting or parking fees may apply if applicable."
    },
    {
        question: "Is the service available 24/7 for Pune to Hyderabad travel?",
        answer: "Yes, we operate round-the-clock so you can book your trip at any time."
    },
    {
        question: "What payment methods are accepted for the rental cab?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Raghav Sharma',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The Innova Crysta rental from Pune to Hyderabad was very comfortable and the driver was punctual and professional.”',
    },
    {
        name: 'Ms. Priya Nair',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent service with Meghana Cab. The Innova Crysta was clean and spacious, making our long trip pleasant.”',
    },
];













































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];








const puneToHyderabadInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Hyderabad Innova Crysta Rental Cab",
  "description": "Book Innova Crysta cab from Pune to Hyderabad with chauffeur-driven AC taxi service. Available for one way and round trips, suitable for family and business travel at affordable prices.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Outstation Taxi Service",
  "areaServed": {
    "@type": "City",
    "name": "Hyderabad"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-hyderabad-innova-crysta-cab"
  }
};








    return (
        <div>

<Helmet>
  <title>Pune to Hyderabad Innova Crysta Cab | Chauffeur Driven AC Taxi</title>
  <meta
    name="description"
    content="Hire chauffeur-driven Innova Crysta cab for Pune to Hyderabad travel. One way and round trip AC taxi booking available for family and business trips."
  />
  <meta
    name="keywords"
    content="Pune to Hyderabad Innova Crysta Cab Booking, One Way Innova Crysta Pune Hyderabad, Round Trip Innova Crysta Pune Hyderabad, AC Innova Crysta Taxi Pune Hyderabad, Chauffeur Driven Innova Crysta Pune Hyderabad, Private Innova Crysta Taxi Pune Hyderabad, Online Booking Innova Crysta Pune Hyderabad, Family Innova Crysta Trip Pune Hyderabad, Budget Innova Crysta Cab Pune Hyderabad"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToHyderabadInnovaSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/42.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetohyderabadinnova;